export const getIconType = ({
    isFolder,
    ext,
    kind,
    isVirus,
    isAutoDelete,
    ignoreFolderType,
}: {
    isFolder?: boolean;
    ext?: string;
    kind?: string;
    isVirus?: boolean;
    isAutoDelete?: boolean;
    ignoreFolderType?: boolean;
}): string => {
    if (isVirus) {
        return 'virus';
    }

    if (isFolder) {
        if (ignoreFolderType) {
            return 'folder';
        }

        if (isAutoDelete) {
            return 'folder-autodelete';
        }

        if (kind === 'shared') {
            return 'folder-shared';
        }

        if (kind === 'mounted' || kind === 'domain-folder') {
            return 'folder-mounted';
        }

        if (kind === 'camera-upload') {
            return 'folder-camera';
        }

        return 'folder';
    }

    return ext || 'unknown';
};
